<template>
    <div class="filtro">
        <v-navigation-drawer
            ref="navigation"
            v-model="valueData"
            fixed
            temporary
            right
            :width="width"
            :height="alturaFooter"
        >
            <slot name="header">
                <div
                    class="close-filtro"
                    @click="$emit('input', false)"
                >
                    <icon name="x" :size="20"/>
                </div>
                <v-row class="mx-2 pb-6 pt-3">
                    <v-col cols="auto">
                        <div class="font-primaria font-weight-bold title primary1--text">
                            FILTRO
                        </div>
                    </v-col>
                </v-row>
            </slot>
            <div class="body">
                <slot name="body"/>
            </div>
            <slot name="footer">
                <v-row
                    class="mx-1"
                    align="end"
                >
                    <v-col class="pr-1">
                        <button-cadu
                            outline
                            @click="$emit('limparFiltro')"
                        >
                            LIMPAR FILTRO
                        </button-cadu>
                    </v-col>
                    <v-col cols="auto" class="pl-1">
                        <button-cadu
                            @click="$emit('filtrar')"
                        >
                            FILTRAR
                        </button-cadu>
                    </v-col>
                </v-row>
            </slot>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: false
    },
    width: {
      type: String,
      default: '340'
    }
  },
  data () {
    return {
      areaData: '',
      alturaFooter: 0
    }
  },
  beforeMount () {
    this.heightFooter()
  },
  mounted () {
    window.addEventListener('resize', this.heightFooter)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.heightFooter)
  },
  methods: {
    async heightFooter () {
      this.alturaFooter = 0
      await this.$nextTick()
      this.alturaFooter = window.innerHeight - 60
      // if (this.alturaTela() !== heightNavigation) {
      //     this.alturaFooter = this.alturaTela() - heightNavigation
      // }
    },
    alturaTela () {
      return window.innerHeight - 60
    }
  },
  computed: {
    valueData: {
      get: function () { return this.value },
      set: function (newValue) {
        document.documentElement.style.overflow = newValue ? 'hidden' : 'hidden auto'
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style lang="sass">
.body
    overflow: hidden
    height: calc(100% - 152px)

.filtro > .v-navigation-drawer
    top: 60px !important
    z-index: 99999
    box-shadow: none
    .v-navigation-drawer__content
        overflow: hidden

#app > .v-overlay
    z-index: 111 !important

.close-filtro
    position: absolute
    right: 26px
    top: 18px
    cursor: pointer

</style>
